import React, { Component, Fragment, useState, useEffect } from "react";
import { Switch, Route, Redirect, Link } from "react-router-dom";


export default (props) => {
    return(<Fragment>
        <div className="main"> Notifications </div>
    </Fragment>)
}